@if (isLoggedIn()) {
  <div class="header">
    <span class="leftHeaderContent">
      <a tabindex="-1" routerLink="main">
        <img alt="Encompass Logo" src="assets/encompass_logo.png" height="60"/>
      </a>
    </span>
    <span class="spacer"></span>
    <div class="menu">
      <div class="pageLinks">
        @if (!isOutsideEngineer()) {
          <span>
            @if (hasRole('IT')) {
              <a routerLink="product" routerLinkActive="linkActive">Product Master</a>
            }
            <a  routerLink="organization" routerLinkActive="linkActive">Organizations</a>
            <a  routerLink="person" routerLinkActive="linkActive">Person</a>
            <a routerLink="quotes" routerLinkActive="linkActive">Quotes</a>
            <a routerLink="orders" routerLinkActive="linkActive">Orders</a>
          </span>
        }
        <!-- <a routerLink="ratings" routerLinkActive="linkActive">Ratings</a> -->
        @if (!isOutsideEngineer()) {
          <a routerLink="opportunities" routerLinkActive="linkActive">Opportunities</a>
        }
      </div>
    </div>
    <span class="spacer"></span>
    <div class="rightHeaderContent">
      <div class="logoContainer">
        <!--      <a tabindex="-1" target="_blank" href="{{ getCompanyWebsite() }}">-->
        <!--        <img alt="IEC Logo" src="assets/{{ getHeaderLogoWhite() }}" height="40" />-->
      <!--      </a>-->
    </div>
    <div class="usernameLabel">
      <button matButton="text" [matMenuTriggerFor]="userMenu">
        <span>
          <label>{{ getUsername() }}</label>
          <mat-icon class="size-16">arrow_drop_down</mat-icon>
        </span>
      </button>
      <mat-menu #userMenu="matMenu" [overlapTrigger]="false">
        @if (!isOutsideEngineer()) {
          <button mat-menu-item (click)="delegateTasks()">
            <label class="menuLabel">Delegate Tasks</label>
          </button>
        }
        <button mat-menu-item (click)="logout()">
          <label class="menuLabel">Log Out</label>
        </button>
      </mat-menu>
    </div>
  </div>
</div>
}
<div class="content">
  <router-outlet></router-outlet>
</div>
<div class="footer">
  <p>
    Copyright {{ getCurrentYear() }} CCG.
  </p>
  @if (!isLoggedIn()) {
    <p>This software is considered intellectual property by CCG and CCG is the sole owner of the
      intellectual property. This software includes, but is not limited to product selection, configuration, drawing,
      design and pricing programs, which may only be used in furtherance of sales for the benefit of CCG. Unauthorized
    distribution or copying of the software is prohibited and may be considered a breach of the agreement.</p>
  }
</div>
